import {Component, OnInit, Input, Output, EventEmitter, QueryList} from '@angular/core';
import {NavService} from '../../../../services/nav.service';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {TasksModel} from '../../../tasks/models/tasks.model';
import {TasksService} from '../../../tasks/tasks.service';
import {JourneyStageDetailsModel} from '../../models/journey-page.model';
import {AnalyticsService} from '../../../../services/analytics.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../../services/events.service';
import {ActivatedRoute} from '@angular/router';
import {IonContent, LoadingController} from '@ionic/angular';

@Component({
    selector: 'app-learning-journey-list-template',
    templateUrl: './list-template.component.html',
    styleUrls: ['./list-template.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})
export class LearningJourneyListTemplateComponent implements OnInit {

    @Output() goToStage: EventEmitter<number> = new EventEmitter();
    @Output() doClick: EventEmitter<number> = new EventEmitter();
    @Output() doChangeSaveButton: EventEmitter<any> = new EventEmitter();

    @Input() container: IonContent;
    @Input() stage: JourneyStageDetailsModel = null;
    @Input() list: TasksModel[] = [];

    subscriptions: Subscription[] = [];
    fragment: string = null;

    constructor(
        private linkSystem: NavService,
        private analytics: AnalyticsService,
        private event: EventsService,
        private tasksService: TasksService,
        private loadingController: LoadingController,
        private route: ActivatedRoute) {
      this.fragment = this.route.snapshot.fragment ?? null;
    }

    ngOnInit() {
      console.log(this.container);

      // if (this.fragment && this.fragment.startsWith('section-')) {
      //   const section = document.getElementById(this.fragment);
      //   if (section) {
      //     setTimeout(() => {
      //       console.log('Scrolling to section:', this.fragment);
      //       section.scrollIntoView({behavior: 'smooth'});
      //     }, 500);
      //   }
      // }
      // && this.container) {
      //   this.container.scrollToPoint(0, document.getElementById(this.fragment).offsetTop, 500);
      //   const container = document.getElementById(this.containerId);
      //   container.scrollToPoint(0, document.getElementById('stage-' + index).offsetTop, 500);
      // }
    }

    ngAfterViewInit() {
      if (this.fragment && this.fragment.startsWith('section-')) {
        this.presentLoadingWithOptions();
        setTimeout(() => {
          this.scrollToSection(this.fragment);
        }, 1000);
      }
    }

    scrollToSection(sectionId: string) {
      const section = document.getElementById(sectionId);
      if (section) {
        this.container.scrollToPoint(0, section.offsetTop, 500);
      }
    }

    isDisabled(task) {
        return task.disabled;
    }

    onFormChange(value) {
        this.doChangeSaveButton.emit(value);
    }

  async presentLoadingWithOptions() {
    await (await (this.loadingController.create({
      duration: 700,
      translucent: true,
      message: null, // 'Please wait...',
      cssClass: 'loading-no-message'
    }))).present();
  }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
